import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { PropositionType } from './proposition-type.interface';
import { PropositionTypeService } from './proposition-type.service';

const service = new PropositionTypeService();

export interface PropositionTypeState {
   propositionTypes: Array<PropositionType>;
}

const PropositionTypeStore: Module<PropositionTypeState, StoreState> = {
   namespaced: true,
   state: {
      propositionTypes: [],
   },
   getters: {
      propositionTypes: (state) => state.propositionTypes,
   },
   mutations: {
      SET_PROPOSITION_TYPES(state, propositionTypes: Array<PropositionType>) {
         state.propositionTypes = propositionTypes;
      },
   },
   actions: {
      async getPropositionTypes(context, query: LocationQuery) {
         const response = await service.getPropositionTypes(query);
         context.commit('SET_PROPOSITION_TYPES', response.data);
         return response.data;
      },
   },
};

export default PropositionTypeStore;
